import { render, staticRenderFns } from "./forex-market-bulletin.vue?vue&type=template&id=654fab65&scoped=true"
import script from "./forex-market-bulletin.vue?vue&type=script&lang=js"
export * from "./forex-market-bulletin.vue?vue&type=script&lang=js"
import style0 from "./forex-market-bulletin.vue?vue&type=style&index=0&id=654fab65&prod&lang=css"
import style1 from "./forex-market-bulletin.vue?vue&type=style&index=1&id=654fab65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654fab65",
  null
  
)

export default component.exports